import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/constants";
import { GoldButton } from "../components/site/Primitives";
import SEO from "../components/SEO";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/posts/slug/${slug}`).then(({ data }) => setPost(data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4">
      <p className="text-zinc-400">Artigo não encontrado.</p>
      <GoldButton to="/blog">Voltar ao blog</GoldButton>
    </div>
  );
  if (!post) return <div className="min-h-[60vh] flex items-center justify-center text-zinc-500">Carregando...</div>;

  return (
    <div>
      <SEO title={`${post.title} | Blog`} description={post.excerpt} />
      <article className="max-w-3xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
        <Link to="/blog" className="inline-flex items-center gap-2 text-zinc-500 hover:text-gold text-sm mb-8 transition-colors"><ArrowLeft className="w-4 h-4" /> Voltar ao blog</Link>
        <span className="overline-label text-xs text-gold">{post.category}</span>
        <h1 className="font-heading font-700 uppercase tracking-tight text-white text-3xl lg:text-5xl leading-[1.05] mt-3">{post.title}</h1>
        <div className="aspect-[16/9] overflow-hidden rounded-sm border border-white/10 my-10">
          <img src={post.cover} alt={post.title} className="w-full h-full object-cover" />
        </div>
        <div className="space-y-5 text-zinc-300 leading-relaxed text-lg">
          {(post.body || "").split("\n").filter(Boolean).map((p, i) => <p key={i}>{p}</p>)}
        </div>
        <div className="mt-12 pt-8 border-t border-white/10">
          <GoldButton to="/protese-capilar" size="lg">QUERO FAZER UMA AVALIAÇÃO</GoldButton>
        </div>
      </article>
    </div>
  );
}
